import { render, staticRenderFns } from "./SoapBuilder.vue?vue&type=template&id=03853b89&"
import script from "./SoapBuilder.vue?vue&type=script&lang=js&"
export * from "./SoapBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports